import styled from "styled-components";

export const FullScreenWrapper = styled.div`
  min-height: 100vh;
`;
